import * as React from 'react';
import { Select } from '@cian/ui-kit/select';
import * as styles from './Packages.css';
import { IFormattedPackage } from '../../../../redux/reducers';

interface IPackagesProps {
  activePackageId: string | null;
  packages: IFormattedPackage[];
  onChangePackage(newPackageId: string): void;
}

export const Packages = ({ activePackageId, packages, onChangePackage }: IPackagesProps) => {
  return (
    <div className={styles['packages']}>
      <Select
        value={activePackageId}
        options={packages}
        placeholder="Доступные пакеты"
        onChange={onChangePackage}
      />
    </div>
  );
};
